import React, { Component } from 'react';

class PostBidField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            price: props.price || '',
            isPriceUpdated: false,
            trip_id: props.lineItem.trip_id,
            lot_trip_child_id: props.lineItem.lot_trip_child_id,
            material_code_description: props.lineItem.material_code_description
        }
    }

    onChangePrice = (e) => {
        const { rfq, lineItem, isDepotWise, trip } = this.props;
        if (!JSON.parse(localStorage.getItem("termsAndConditionsAccepted"))){
            alert('Please Accept Terms And Conditions');
            return;
         }
        this.setState({ 
            price: e.target.value,
            isError: false
        }, () => {
            this.props.postDisposalBid({
                "rfq_id": rfq.id,
                "trip_id": lineItem.trip_id,
                "price": this.state.price && Number(this.state.price),
                "bid_quantity_cost": this.state.price && (Number(this.state.price) * lineItem.quantity),
                "tat": {
                    "value": 0,
                    "name": "",
                    "unit": 0
                },
                "lot_trip_child_id": lineItem.lot_trip_child_id,
                "material_code_description": !isDepotWise ? lineItem.material_code_description : undefined   
            }, 1, false, lineItem, trip);
        });
    }

    onBlurChange = (e, price) => {
        e.preventDefault();
        const { trip, bidSubmitList, lineItem, rfq, isDepotWise } = this.props;
        const { trip_id, lot_trip_child_id, material_code_description } = this.state;
        if(price && (!isDepotWise ? ((lot_trip_child_id === lineItem.lot_trip_child_id) && (material_code_description === lineItem.material_code_description)) : (trip_id === lineItem.trip_id)) && ((price && Number(price)) < (lineItem.bidding_and_payments || {}).qbr)) {
            this.setState({ 
                price: '',
                isError: true
            }, () => {
                this.props.postDisposalBid({
                    "rfq_id": rfq.id,
                    "trip_id": lineItem.trip_id,
                    "price": this.state.price && Number(this.state.price),
                    "bid_quantity_cost": this.state.price && (Number(this.state.price) * lineItem.quantity),
                    "tat": {
                        "value": 0,
                        "name": "",
                        "unit": 0
                    },
                "lot_trip_child_id": lineItem.lot_trip_child_id,
                "material_code_description": !isDepotWise ? lineItem.material_code_description : undefined
                }, 2, true, lineItem, trip);
            });
            // alert('Bid Price should be greater than MSP');
            return;
        }
        // if(price && price !== lineItem.price) {
        //     const tripPrice = (trip.sub_trip_disposal_product || []).filter(sTrip => sTrip.price);
        //     const bidList = (bidSubmitList || []).filter(sBid => sBid.lot_trip_child_id === trip.lot_trip_parent_id);
        //     if(!tripPrice.length && (bidList.length === trip.sub_trip_disposal_product.length)) {
        //         // this.props.postBidAll(1, bidList);
        //         this.props.readyToPostBid(bidList);
        //     } else if((tripPrice.length === trip.sub_trip_disposal_product.length)  && bidList.length > 0) {
        //         // this.props.postBidAll(1, bidList);
        //         this.props.readyToPostBid(bidList);
        //     }
        // }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { bidSubmitList } = nextProps;
        if(!bidSubmitList.find(bid => bid.trip_id === nextProps.lineItem.trip_id)) {
            this.setState({
                price: nextProps.lineItem.price || ''
            });
        }
    }


    render() {
        return (
            <div key={this.state.trip_id}>
                <input 
                    style={{
                        'borderBottom': '1px solid rgba(151, 151, 151, 0.2)', 'background-color':this.props.colorCode
                    }}
                    type="number"
                    key={this.state.trip_id}
                    value={this.state.price}
                    onChange={(e) => this.onChangePrice(e)}
                    onKeyDown={e => (["e", "E", "+", "-", "."].includes(e.key)) && e.preventDefault()}
                    onBlur={(e) => this.onBlurChange(e, this.state.price)}
                />
            </div>
        )
    }
}

export default PostBidField;